// Libraries
var React = require('react');

// Components
var SubNavigationBar = require('./SubNavigationBar');

// Styles
require('./SubNavigationModule.scss');

class SubNavigationModule extends React.Component {
	render() {
		return (
			<div className="SubNavigation">
				<SubNavigationBar {...this.props.data} />
			</div>
		)
	}
}

module.exports = SubNavigationModule;


// WEBPACK FOOTER //
// ./src/components/Navigation/SubNavigation/SubNavigationModule.js